import './index.scss';
import ModalManager from 'utils/modal_manager';

(function ($) {
  const $page = $('.js-guide-page');

  $('.js-open-modal', $page).on('click', e => {
    e.preventDefault();
    ModalManager.open('#js-guide-not-premium-user-modal');
  });

})(jQuery);
